export default __webpack_public_path__ + "static/simple-line-3cbdcff905bf59b9063eaee7d8c210fa.png";